<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">
    <div class="filter my-3">
      <div class="filter-head">
        <h4>طلبات تغيير الجهاز ({{ requests.total ?? 0 }})</h4>
      </div>
      <div class="row mb-3">
        <div class="col-lg-3 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label>الحالة</label>
            <Dropdown v-model="status" :options="statusOptions" showClear optionLabel="title"
                      placeholder="كل الحالات" @change="fetchRequests(1)" />
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>رقم الحجز</th>
            <th>الطالب</th>
            <th>السنة الدراسية</th>
            <th>الجهاز المطلوب</th>
            <th>الحالة</th>
            <th>تمت المراجعة بواسطة</th>
            <th>تاريخ الطلب</th>
            <th>التحكم</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in requests.data" :key="r.id">
            <td>{{ r.reservation_number ?? '-' }}</td>
            <td>{{ r.student_name ?? '-' }}</td>
            <td>{{ r.academic_year ?? '-' }}</td>
            <td>{{ [r.requested_brand, r.requested_model].filter(Boolean).join(' - ') || '-' }}</td>
            <td>
              <span v-if="r.status === 'pending'" class="status-badge status-badge--pending">قيد الانتظار</span>
              <span v-else-if="r.status === 'approved'" class="status-badge status-badge--accepted">تمت الموافقة</span>
              <span v-else class="status-badge status-badge--rejected">مرفوض</span>
            </td>
            <td>{{ r.reviewer ?? '-' }}</td>
            <td>{{ r.created_at }}</td>
            <td class="text-nowrap">
              <template v-if="r.status === 'pending'">
                <button class="btn btn-success text-white mx-1" type="button" :disabled="busyId === r.id" @click="approve(r)">
                  <i class="pi pi-spin pi-spinner" v-if="busyId === r.id"></i>
                  <i class="pi pi-check" v-else></i>
                  اعتماد
                </button>
                <button class="btn btn-danger text-white mx-1" type="button" :disabled="busyId === r.id" @click="reject(r)">
                  <i class="pi pi-times"></i>
                  رفض
                </button>
              </template>
              <span v-else>-</span>
            </td>
          </tr>
          <tr v-if="!requests.data || requests.data.length === 0">
            <td colspan="8" class="text-center py-4">لا توجد طلبات</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row" v-if="requests.total">
      <div class="col-12">
        <pagination :data="requests" class="mx-auto d-flex align-items-center justify-content-center pagination"
                    @pagination-change-page="fetchRequests">
          <template v-slot:prev-nav>&lt;</template>
          <template v-slot:next-nav>&gt;</template>
        </pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Dropdown from 'primevue/dropdown';
import pagination from 'laravel-vue-pagination';
import Breadcrumb from '@/components/global/breadcrumb.vue';

export default {
  name: 'DeviceChangeRequests',
  components: { Breadcrumb, Dropdown, pagination },
  data() {
    return {
      requests: { data: [], total: 0 },
      status: null,
      statusOptions: [
        { id: 'pending', title: 'قيد الانتظار' },
        { id: 'approved', title: 'تمت الموافقة' },
        { id: 'rejected', title: 'مرفوض' },
      ],
      busyId: null,
      breadcrumbs: [
        { name: 'الرئيسية', path: '/' },
        { name: 'الأجهزة المسجلة', path: '/students/devices' },
        { name: 'طلبات تغيير الجهاز', path: '/students/device-requests' },
      ],
    };
  },
  methods: {
    fetchRequests(page = 1) {
      const params = { page };
      if (this.status) params.status = this.status.id;
      if (this.$route.query.user_id) params.user_id = this.$route.query.user_id;

      axios.get('/devices/requests', { params }).then(({ data }) => {
        this.requests = data.data;
      }).catch(() => {
        this.requests = { data: [], total: 0 };
      });
    },
    approve(r) {
      Swal.fire({
        title: 'اعتماد طلب تغيير الجهاز؟',
        text: 'سيتم استبدال الجهاز المسجل الحالي بالجهاز المطلوب في هذا الطلب.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'اعتماد',
        cancelButtonText: 'رجوع',
      }).then((result) => {
        if (!result.isConfirmed) return;
        this.busyId = r.id;
        axios.post(`/devices/requests/${r.id}/approve`).then(({ data }) => {
          if (data.status) {
            Swal.fire('', data.message, 'success');
            r.status = 'approved';
          } else {
            Swal.fire('', data.message, 'error');
          }
        }).catch((err) => {
          Swal.fire('', err.response?.data?.message || 'تعذر اعتماد الطلب', 'error');
        }).finally(() => { this.busyId = null; });
      });
    },
    reject(r) {
      Swal.fire({
        title: 'رفض الطلب؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'رفض',
        cancelButtonText: 'رجوع',
      }).then((result) => {
        if (!result.isConfirmed) return;
        this.busyId = r.id;
        axios.post(`/devices/requests/${r.id}/reject`).then(({ data }) => {
          if (data.status) {
            Swal.fire('', data.message, 'success');
            r.status = 'rejected';
          } else {
            Swal.fire('', data.message, 'error');
          }
        }).catch((err) => {
          Swal.fire('', err.response?.data?.message || 'تعذر رفض الطلب', 'error');
        }).finally(() => { this.busyId = null; });
      });
    },
  },
  mounted() {
    this.fetchRequests();
  },
};
</script>
